import React from 'react'
import { cn } from '@/lib/utils'
import { ScrollProgress } from '../magicui/scroll-progress'
import { SidebarTriggerWithPersona } from './persona-switcher'

interface HeaderProps extends React.HTMLAttributes<HTMLElement> {
  fixed?: boolean
  ref?: React.Ref<HTMLElement>
}

export const Header = ({
  className,
  fixed,
  children,
  ...props
}: HeaderProps) => {
  const [offset, setOffset] = React.useState(0)

  React.useEffect(() => {
    const onScroll = () => {
      setOffset(document.body.scrollTop || document.documentElement.scrollTop)
    }

    // Add scroll listener to the body
    document.addEventListener('scroll', onScroll, { passive: true })

    // Clean up the event listener on unmount
    return () => document.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header
      className={cn(
        'flex items-center gap-3 sm:gap-4 bg-background p-4 h-16',
        fixed && 'header-fixed peer/header w-[inherit] fixed z-50 rounded-md',
        offset > 10 && fixed ? 'shadow' : 'shadow-none',
        className
      )}
      {...props}
    >
      <SidebarTriggerWithPersona
        variant='outline'
        className='scale-125 sm:scale-100'
      />
      {children}
      <ScrollProgress className='top' />
    </header>
  )
}

Header.displayName = 'Header'
